import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { EmailRoute } from '@/types/integrations.ts';
import { INTEGRATION_CONFIG_EMAIL_ROUTES_KEY } from '@/utils/queryKeys.ts';
import { get_email_aliases_url } from '@/utils/urls.ts';

type CreateEmailAliasParams = {
  stepId: string;
  localPart: string;
};

const useCreateEmailAlias = (): UseMutationResult<EmailRoute, AxiosError, CreateEmailAliasParams> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stepId, localPart }) => {
      const response = await apiClient.post<EmailRoute>(get_email_aliases_url(automationId, stepId), {
        local_part: localPart,
      });
      return response.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: INTEGRATION_CONFIG_EMAIL_ROUTES_KEY(automationId, variables.stepId),
      });
    },
  });
};

export default useCreateEmailAlias;
